// import Home from '../views/Home.vue';

export default [
    {
        path: '/',
        // name: 'Home',
        // component: Home,
        redirect: '/hall',
    },
    {
        path: '/mine/service',
        name: 'mine-service',
        component: () => import('../views/mine/service.vue'),
        meta: {
            title: '客服',
            showTabber: true,
        },
    },
    {
        path: '/mine/index',
        name: 'mineIndex',
        component: () => import('../views/mine/index.vue'),
        meta: {
            title: '我的数字运力',
            showTabber: true,
        },
    },
    {
        path: '/mine/baseMsg',
        name: 'mineBaseMsg',
        component: () => import('../views/mine/baseMsg.vue'),
        meta: {
            title: '我的账户',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/baseDetail',
        name: 'mineBaseDetail',
        component: () => import('../views/mine/baseDetail.vue'),
        meta: {
            title: '个人信息',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/editPwd',
        name: 'mineEditPwd',
        component: () => import('../views/mine/editPwd.vue'),
        meta: {
            title: '修改密码',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/companyInfo',
        name: 'mineCompanyInfo',
        component: () => import('../views/mine/companyInfo.vue'),
        meta: {
            title: '企业信息',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/companyApt',
        name: 'mineCompanyApt',
        component: () => import('../views/mine/companyApt.vue'),
        meta: {
            title: '企业资质',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/companyImg',
        name: 'mineCompanyImg',
        component: () => import('../views/mine/companyImg.vue'),
        meta: {
            title: '企业照片',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/linkman',
        name: 'mineLinkman',
        component: () => import('../views/mine/linkman.vue'),
        meta: {
            title: '联系人',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/editLinkman',
        name: 'mineEditLinkman',
        component: () => import('../views/mine/editLinkman.vue'),
        meta: {
            title: '编辑联系人',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/transport',
        name: 'mineTransport',
        component: () => import('../views/mine/transport.vue'),
        meta: {
            title: '运力信息',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/truckInfo',
        name: 'mineTruckInfo',
        component: () => import('../views/mine/truckInfo.vue'),
        meta: {
            title: '车辆信息',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/addTruck',
        name: 'mineAddTruck',
        component: () => import('../views/mine/addTruck.vue'),
        meta: {
            title: '车辆信息',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/LineInfo',
        name: 'mineLineInfo',
        component: () => import('../views/mine/LineInfo.vue'),
        meta: {
            title: '线路运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/addLine',
        name: 'mineAddLine',
        component: () => import('../views/mine/addLine.vue'),
        meta: {
            title: '线路运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/inCityInfo',
        name: 'mineInCityInfo',
        component: () => import('../views/mine/inCityInfo.vue'),
        meta: {
            title: '同城运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/mine/addCityLine',
        name: 'mineAddCityLine',
        component: () => import('../views/mine/addCityLine.vue'),
        meta: {
            title: '线路运力',
            showTabber: false,
            login: true,
        },
    },
    // 入驻
    // {
    //     path: '/auth/baseMsg',
    //     name: 'authBaseMsg',
    //     component: () => import('../views/mine/baseMsg.vue'),
    //     meta: {
    //         title: '我的账户',
    //         showTabber: false,
    //         login: true,
    //     },
    // },
    // {
    //     path: '/auth/baseDetail',
    //     name: 'authBaseDetail',
    //     component: () => import('../views/mine/baseDetail.vue'),
    //     meta: {
    //         title: '个人信息',
    //         showTabber: false,
    //         login: true,
    //     },
    // },
    // {
    //     path: '/auth/editPwd',
    //     name: 'authEditPwd',
    //     component: () => import('../views/mine/editPwd.vue'),
    //     meta: {
    //         title: '修改密码',
    //         showTabber: false,
    //         login: true,
    //     },
    // },
    {
        path: '/auth/companyInfo',
        name: 'authCompanyInfo',
        component: () => import('../views/mine/companyInfo.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/companyApt',
        name: 'authCompanyApt',
        component: () => import('../views/mine/companyApt.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/companyImg',
        name: 'authCompanyImg',
        component: () => import('../views/mine/companyImg.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    // {
    //     path: '/auth/linkman',
    //     name: 'authLinkman',
    //     component: () => import('../views/mine/linkman.vue'),
    //     meta: {
    //         title: '联系人',
    //         showTabber: false,
    //         login: true,
    //     },
    // },
    {
        path: '/auth/editLinkman',
        name: 'authEditLinkman',
        component: () => import('../views/mine/editLinkman.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/transport',
        name: 'authTransport',
        component: () => import('../views/mine/transport.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/truckInfo',
        name: 'authTruckInfo',
        component: () => import('../views/mine/truckInfo.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/addTruck',
        name: 'authAddTruck',
        component: () => import('../views/mine/addTruck.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/LineInfo',
        name: 'authLineInfo',
        component: () => import('../views/mine/LineInfo.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/addLine',
        name: 'authAddLine',
        component: () => import('../views/mine/addLine.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/inCityInfo',
        name: 'authInCityInfo',
        component: () => import('../views/mine/inCityInfo.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/addCityLine',
        name: 'authAddCityLine',
        component: () => import('../views/mine/addCityLine.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/auth/complete',
        name: 'authComplete',
        component: () => import('../views/mine/authComplete.vue'),
        meta: {
            title: '入驻数字运力',
            showTabber: false,
            login: true,
        },
    },

    // 货主招标
    {
        path: '/tendering',
        name: 'tendering',
        component: () => import('../views/tendering'),
        meta: {
            title: '招标',
            showTabber: true,
            login: true,
        },
    },
    {
        path: '/tendering/detail',
        name: 'tendering.detail',
        component: () => import('../views/tendering/detail'),
        meta: {
            title: '招标详情',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/tendering/fleetDetail',
        name: 'tendering.fleetDetail',
        component: () => import('../views/tendering/fleetDetail'),
        meta: {
            title: '车队投标明细',
            login: true,
        },
    },
    // 车队投标
    {
        path: '/tenderingL',
        name: 'tenderingL',
        component: () => import('../views/tenderingLower'),
        meta: {
            title: '招标',
            showTabber: true,
            login: true,
        },
    },
    {
        path: '/tenderingL/detail',
        name: 'tenderingL.detail',
        component: () => import('../views/tenderingLower/detail'),
        meta: {
            title: '招标详情',
            showTabber: false,
            login: true,
        },
    },

    // 大厅
    {
        path: '/hall',
        name: 'hall',
        component: () => import('../views/hall'),
        meta: {
            title: '招标大厅',
            showTabber: true,
        },
    },
    {
        path: '/hall/normalTender',
        name: 'hall.normalTender',
        component: () => import('../views/hall/normalTender'),
        meta: {
            title: '普通招标',
            showTabber: false,
            // login: true,  20181227修改
        },
    },
    {
        path: '/hall/detail',
        name: 'hall.detail',
        component: () => import('../views/hall/detail'),
        meta: {
            title: '招标详情',
            showTabber: false,
        },
    },
    {
        path: '/hall/confirmApplication',
        name: 'hall.confirmApplication',
        component: () => import('../views/hall/confirmApplication'),
        meta: {
            title: '确认报名',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/hall/signUpSuccess',
        name: 'hall.signUpSuccess',
        component: () => import('../views/hall/signUpSuccess'),
        meta: {
            title: '报名成功',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/hall/selectContact',
        name: 'hall.selectContact',
        component: () => import('../views/hall/selectContact'),
        meta: {
            title: '选择联系人',
            showTabber: false,
            login: true,
        },
    },
    // 收藏
    {
        path: '/collect',
        name: 'collect',
        component: () => import('../views/collect'),
        meta: {
            title: '收藏',
            showTabber: false,
            login: true,
        },
    },
    {
        path: '/login/load',
        name: 'login.load',
        component: () => import('../views/login/load'),
        meta: {
            title: '登录',
            showTabber: false,
            login: false,
        },
    },
];
